var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ob1-popin-modal2",
    {
      attrs: { id: _vm.modalId, "aria-labelledby": _vm.modalLabelId },
      on: { "ob1-popin-modal-click": _vm.closePopin },
    },
    [
      _c("div", {
        staticClass: "h4",
        attrs: { id: _vm.modalLabelId },
        domProps: { innerHTML: _vm._s(_vm.messages.title) },
      }),
      _vm._v(" "),
      _c("recovery-simulator", {
        ref: "simulator",
        attrs: {
          shop: _vm.shop,
          messages: _vm.messages,
          "modal-id": _vm.modalId,
        },
        on: { "update-recovery-simulation": _vm.updateRecoveryPrice },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }